import React from 'react'

import Layout from '../components/layout'

const RegistrationPage = () => (
  <Layout>
    <article className="pa4 black-80">
        <form name="registration" action="registration-success" accept-charset="utf-8" netlify-honeypot="honeypot"  data-netlify="true">
            <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
                Online Registration
            </h1>
            <input type="hidden" name="form-name" value="registration" />
            <fieldset id="registration" className="ba b--transparent ph0 mh0">
                <div className="hidden">
                    <label>Don’t fill this out if you're human: <input name="honeypot" /></label>
                </div>
                <div className="fl w-50 pa2">
                    <div className="measure">
                        <label for="name" className="f6 b db mb2">Name </label>
                        <input id="name" name="name" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="name-desc" required />
                        {/* <small id="name-desc" className="f6 black-60 db mb2">Helper text for the form control.</small> */}
                    </div>
                    <div className="measure">
                        <label for="address" className="f6 b db mb2">Address </label>
                        <input id="address" name="address" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="address-desc" required />
                        {/* <small id="address-desc" className="f6 black-60 db mb2">Helper text for the form control.</small> */}
                    </div>
                    <div className="measure">
                        <label for="number" className="f6 b db mb2">Phone Number</label>
                        <input id="number" name="number" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="tel" aria-describedby="number-desc" required />
                        {/* <small id="number-desc" className="f6 black-60 db mb2">A contact number where we can reach you.</small> */}
                    </div>
                    <div className="measure">
                        <label for="email" className="f6 b db mb2">Email </label>
                        <input id="email" name="email" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="email" aria-describedby="email-desc" required />
                        {/* <small id="email-desc" className="f6 black-60 db mb2">Your contact email address.</small> */}
                    </div>
                    <div className="measure">
                        <label for="exhibition" className="f6 b db mb2">Name of Exhibition </label>
                        <select id="exhibition" name="exhibition" className="input-reset ba b--black-20 pa2 mb2 db w-100" aria-describedby="exhibition-desc">
                            <option value="Twisted Christmas Exhibition">Twisted Christmas Exhibition</option>
                            {/* <option value="Twisted Christmas Exhibition 2">Twisted Christmas Exhibition 2</option>
                            <option value="Twisted Christmas Exhibition 3">Twisted Christmas Exhibition 3</option>
                            <option value="Twisted Christmas Exhibition 4">Twisted Christmas Exhibition 4</option> */}
                        </select>
                        {/* <small id="exhibition-desc" className="f6 black-60 db mb2">You can select more than 1 if needed.</small> */}
                    </div>
                </div>
                <div className="fl w-50 pa2">
                    <div className="measure">
                        <label for="artwork" className="f6 b db mb2">Name of Artwork </label>
                        <input id="artwork" name="artwork" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="artwork-desc" />
                        {/* <small id="artwork-desc" className="f6 black-60 db mb2">The name of your artwork.</small> */}
                    </div>
                    <div className="measure">
                        <label for="dimension" className="f6 b db mb2">Dimension </label>
                        <input id="dimension" name="dimension" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="dimension-desc" />
                        {/* <small id="dimension-desc" className="f6 black-60 db mb2">Please state the measurement (50cm x 50cm).</small> */}
                    </div>
                    <div className="measure">
                        <label for="medium" className="f6 b db mb2">Medium </label>
                        <input id="medium" name="medium" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="medium-desc" />
                        {/* <small id="medium-desc" className="f6 black-60 db mb2">The medium used in creating your artwork.</small> */}
                    </div>
                    <div className="measure">
                        <label for="price" className="f6 b db mb2">Price </label>
                        <input id="price" name="price" className="input-reset ba b--black-20 pa2 mb2 db w-100" type="text" aria-describedby="price-desc" />
                        {/* <small id="price-desc" className="f6 black-60 db mb2">Helper text for the form control.</small> */}
                    </div>
                    <div className="measure" data-netlify-recaptcha="true"></div>
                </div>
            </fieldset>
            <div className="pa2 w-100">
                <input class="mr2" type="checkbox" id="terms" value="terms" required />
                <label for="terms" class="lh-copy"> I confirm that the work is my own original work. The work has not been exhibited publicly in Southland. I agree to the <a className="fw7" href="/conditions/" target="_blank">conditions</a> of entry in every aspect.</label>
            </div>
            <div className="tc mt1 pa2 fl w-100">
                <button className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6" type="submit">Submit</button>
            </div>
        </form>
    </article>
  </Layout>
)

export default RegistrationPage
